/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Trans } from 'react-i18next'
import history from '@services/History'
import Alert from '../../../adminv2/common/Alert'
import { getAlertData } from '../alert/Alert.dux'
import { useSelector } from 'react-redux'

export const CompanyTable = (props) => {
  const alert = useSelector((state) => getAlertData(state))

  let component
  if (!!props.companies.length)
    component = (
      <table className="md-table actions-table">
        <thead>
          <tr>
            <th>
              <Trans>Nombre</Trans>
            </th>
            <th className="actions-col">
              <Trans>Acciones</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {props.companies.map((company) => (
            <tr key={company.id} style={{ textAlign: 'center' }}>
              <td>{company.name}</td>
              <td>
                <div className="actions-container">
                  <span onClick={() => history.push(`${props.actionLink}/${company.id}`)} className="far fa-eye" />
                  <span onClick={() => props.showGroupModal(company)} className="fas fa-users" />
                  <span
                    onClick={() => history.push(`${props.actionLink}/update/${company.id}`)}
                    className="far fa-edit"
                  />
                  {/* <span
                    onClick={() => history.push(`${props.actionLink}/specialities/${company.id}`)}
                    className="fas fa-cog"
                  /> */}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  else {
    component = <div>{props.emptyText}</div>
  }
  return (
    <>
      {alert.show ? <Alert timeOut={3000} /> : null}

      {component}
    </>
  )
}
